// extracted by mini-css-extract-plugin
export default {"text":"text_LnPy8","list":"list_laF3L"};